__turbopack_context__.v({
  "cache": "cache-module-scss-module__kJKx0G__cache",
  "label": "cache-module-scss-module__kJKx0G__label",
  "note": "cache-module-scss-module__kJKx0G__note",
  "value": "cache-module-scss-module__kJKx0G__value",
});
